export default "__VITE_ASSET__d9b5660d__"